validParts